import style from './index.module.scss';
import cls from 'classnames';
import { useStore } from '@/store';

export function Currency(props) {
  const { orderObj } = useStore();
  const currency = orderObj?.currencySign?.currencySign;

  return (
    <span className={cls(style.container, props.className)} style={props.style}>
      {currency}
    </span>
  );
}
